import { ServiceLocalize } from '../base';

class ServiceLocalizeProd extends ServiceLocalize {}

export default ServiceLocalizeProd;
